/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import ReactDOM from 'react-dom'
import Amplify from '@aws-amplify/core'
import { Router } from 'react-router-dom'
import { Provider } from 'mobx-react'
import { createBrowserHistory } from 'history'
import { syncHistoryWithStore } from 'mobx-react-router'
import { ErrorBoundary } from 'react-error-boundary'
import ReactGA from 'react-ga'

import './styles.scss'
import './components/Dashboard/styles.scss'
import './components/Errors/styles.scss'
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync'
import { ApolloProvider } from '@apollo/react-hooks'
import Auth from '@aws-amplify/auth'
import App from './components/App'
import * as serviceWorker from './serviceWorker'
import config from './config'

// Stores
import prospects from './stores/prospects'
import search from './stores/search'
import related from './stores/related'
import companyInfo from './stores/companyInfo'
import settings from './stores/settings'
import routing from './stores/routing'
import DefaultErrorFallback from './components/Errors/DefaultErrorFallback'
import SignupContextContainer, { SignupContext } from './context/SignupContextContainer'

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: 'mav-outlook-api',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    ],
  },
})

const { googleAnalytics } = config

if (googleAnalytics.enabled) {
  ReactGA.initialize(googleAnalytics.trackingCode)
}

const browserHistory = createBrowserHistory()

const stores = {
  prospects,
  search,
  related,
  companyInfo,
  settings,
  routing,
}

// initialize graphql client
const graphClient = new AWSAppSyncClient({
  url: config.appsync.ENDPOINT,
  region: config.appsync.REGION,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async (): Promise<string> => (await Auth.currentSession()).getIdToken().getJwtToken(),
  },
  disableOffline: true,
})

const history = syncHistoryWithStore(browserHistory, routing)

ReactDOM.render(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <ApolloProvider client={graphClient as any}>
    <Provider {...stores}>
      <SignupContextContainer>
        <SignupContext.Consumer>
          {signupContext => (
            <Router history={history}>
              <ErrorBoundary
                FallbackComponent={DefaultErrorFallback}
                // eslint-disable-next-line
                onError={(error, info): void => {
                  // We can (and should) also use this ErrorBoundary component
                  // in other places in the project, so that an error in one
                  // part of the app doesn't render the rest of the working app
                  // useless.
                  ReactGA.exception({
                    description: `${error.name} - ${error.message}`,
                    fatal: true,
                  })
                }}
              >
                <App />
              </ErrorBoundary>
            </Router>
          )}
        </SignupContext.Consumer>
      </SignupContextContainer>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
